import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crg-admin-dash',
  templateUrl: './admin-dash.component.html',
})
export class AdminDashComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

  close(alert: any) {
    // this.alert = null;
  }
}
